module.exports = "<app-headlines></app-headlines>\n"